const nav=document.querySelector('.nav');
    const navBrand=document.querySelector('.brand');
    const mobileNavMenu=document.querySelector('.mobile-nav-menu');
    const mobileNavQuery=matchMedia('(max-width:800px)');
    const setMobileMenu=open=>{nav.classList.toggle('menu-open',open);navBrand.setAttribute('aria-expanded',String(open))};
    navBrand.addEventListener('click',event=>{if(!mobileNavQuery.matches)return;event.preventDefault();setMobileMenu(!nav.classList.contains('menu-open'))});
    mobileNavMenu.addEventListener('click',event=>{if(event.target.closest('a'))setMobileMenu(false)});
    document.addEventListener('click',event=>{if(mobileNavQuery.matches&&nav.classList.contains('menu-open')&&!nav.contains(event.target))setMobileMenu(false)});
    document.addEventListener('keydown',event=>{if(event.key==='Escape')setMobileMenu(false)});
    mobileNavQuery.addEventListener('change',()=>setMobileMenu(false));
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals=document.querySelectorAll('.reveal');
    const io=new IntersectionObserver((entries)=>entries.forEach((entry)=>{if(entry.isIntersecting){entry.target.classList.add('visible');io.unobserve(entry.target)}}),{threshold:.16});
    reveals.forEach((el,i)=>{el.style.transitionDelay=`${Math.min((i%4)*90,270)}ms`;io.observe(el)});
    const advantages=document.querySelector('.advantages');
    const advantagesHeadSlot=document.querySelector('.advantages-head-slot');
    const advantagesHead=document.querySelector('.advantages-head');
    const advantagesGrid=document.querySelector('.advantages-grid');
    const advantageCards=[...document.querySelectorAll('.advantage')];
    const comparisonTable=document.querySelector('.comparison .compare-table');
    const capmColumnHead=document.querySelector('.comparison .compare-head .capm');
    const headLeftBlock=document.querySelector('.advantages-head>div');
    const headRightBlock=document.querySelector('.advantages-head>p');
    const logoMorph=document.querySelector('.logo-morph');
    const morphPlatform=document.querySelector('.morph-platform');
    const morphUsp=document.querySelector('.morph-usp');
    const processStory=document.querySelector('.process-story');
    const processSticky=document.querySelector('.process-sticky');
    const processSteps=[...document.querySelectorAll('.process-step')];
    const processVisuals=[...document.querySelectorAll('.process-visual')];
    const processRail=document.querySelector('.process-rail');
    const processMarkers=[...document.querySelectorAll('.process-marker')];
    const processGlass=document.querySelector('.process-glass');
    const cta=document.querySelector('.cta');
    const ctaHeading=document.querySelector('.cta h2');
    const glassProfiles=[
      {w:96,h:78,r:28},
      {w:68,h:94,r:32},
      {w:64,h:96,r:32},
      {w:98,h:76,r:27},
      {w:78,h:84,r:31}
    ];
    const clamp=(n,min,max)=>Math.min(Math.max(n,min),max);
    const documentTop=(el)=>{let top=0,node=el;while(node){top+=node.offsetTop;node=node.offsetParent}return top};
    const desktopHeadMetrics={ready:false,slotTop:0,gridTop:0,height:0,left:0,width:0};
    const desktopHeadMotion={initialized:false,frame:0,lastTime:0,currentY:-220,targetY:-220,currentOpacity:0,targetOpacity:0};
    const paintDesktopHead=(time)=>{
      desktopHeadMotion.frame=0;
      const elapsed=desktopHeadMotion.lastTime?Math.min((time-desktopHeadMotion.lastTime)/1000,.05):.016;
      desktopHeadMotion.lastTime=time;
      const follow=1-Math.exp(-24*elapsed);
      desktopHeadMotion.currentY+=(desktopHeadMotion.targetY-desktopHeadMotion.currentY)*follow;
      desktopHeadMotion.currentOpacity+=(desktopHeadMotion.targetOpacity-desktopHeadMotion.currentOpacity)*follow;
      if(Math.abs(desktopHeadMotion.targetY-desktopHeadMotion.currentY)<.08)desktopHeadMotion.currentY=desktopHeadMotion.targetY;
      if(Math.abs(desktopHeadMotion.targetOpacity-desktopHeadMotion.currentOpacity)<.002)desktopHeadMotion.currentOpacity=desktopHeadMotion.targetOpacity;
      advantagesHead.style.setProperty('--head-group-y',`${desktopHeadMotion.currentY}px`);
      advantagesHead.style.setProperty('--head-group-opacity',String(desktopHeadMotion.currentOpacity));
      if(desktopHeadMotion.currentY!==desktopHeadMotion.targetY||desktopHeadMotion.currentOpacity!==desktopHeadMotion.targetOpacity){
        desktopHeadMotion.frame=requestAnimationFrame(paintDesktopHead);
      }
    };
    const setDesktopHeadTarget=(y,opacity,immediate=false)=>{
      desktopHeadMotion.targetY=y;
      desktopHeadMotion.targetOpacity=opacity;
      if(!desktopHeadMotion.initialized||immediate){
        desktopHeadMotion.initialized=true;
        desktopHeadMotion.currentY=y;
        desktopHeadMotion.currentOpacity=opacity;
        advantagesHead.style.setProperty('--head-group-y',`${y}px`);
        advantagesHead.style.setProperty('--head-group-opacity',String(opacity));
        return;
      }
      if(!desktopHeadMotion.frame)desktopHeadMotion.frame=requestAnimationFrame(paintDesktopHead);
    };
    const measureDesktopHead=()=>{
      advantages.classList.remove('desktop-head-ready');
      advantagesHeadSlot.style.removeProperty('--head-slot-height');
      desktopHeadMetrics.ready=false;
      if(mobileNavQuery.matches){
        if(desktopHeadMotion.frame)cancelAnimationFrame(desktopHeadMotion.frame);
        desktopHeadMotion.frame=0;
        desktopHeadMotion.initialized=false;
        return;
      }
      const slotRect=advantagesHeadSlot.getBoundingClientRect();
      desktopHeadMetrics.slotTop=slotRect.top+scrollY;
      desktopHeadMetrics.gridTop=documentTop(advantagesGrid);
      desktopHeadMetrics.height=advantagesHead.offsetHeight;
      desktopHeadMetrics.left=slotRect.left;
      desktopHeadMetrics.width=slotRect.width;
      advantagesHeadSlot.style.setProperty('--head-slot-height',`${desktopHeadMetrics.height}px`);
      advantagesHead.style.setProperty('--head-fixed-left',`${desktopHeadMetrics.left}px`);
      advantagesHead.style.setProperty('--head-fixed-width',`${desktopHeadMetrics.width}px`);
      advantages.classList.add('desktop-head-ready');
      desktopHeadMetrics.ready=true;
    };
    if(!reduced){
      let sceneFramePending=false;
      let downstreamScenesWereActive=false;
      const updateScene=()=>{
        if(sceneFramePending)return;
        sceneFramePending=true;
        requestAnimationFrame(()=>{
        sceneFramePending=false;
        const y=scrollY;
        const mobile=mobileNavQuery.matches;
        const vh=mobile?(processSticky.clientHeight||innerHeight):innerHeight;
        const ambientProgress=clamp(y/(vh*3.2),0,1);
        const ambientEase=ambientProgress*ambientProgress*(3-2*ambientProgress);
        const baseAmbientX=38+ambientEase*28;
        const baseAmbientY=88-ambientEase*42;
        let ambientX=baseAmbientX;
        let ambientY=baseAmbientY;
        let ambientW=48;
        let ambientH=48;
        let ambientOpacity=.72+Math.sin(ambientProgress*Math.PI)*.16;
        const tableRect=comparisonTable.getBoundingClientRect();
        const downstreamScenesActive=mobile||tableRect.top<=vh*.82;
        let ctaLightEase=0;
        if(downstreamScenesActive){
        downstreamScenesWereActive=true;
        const capmHeadRect=capmColumnHead.getBoundingClientRect();
        const comparisonLightProgress=clamp((vh*.82-tableRect.top)/(vh*.58),0,1);
        const comparisonLightEase=comparisonLightProgress*comparisonLightProgress*(3-2*comparisonLightProgress);
        const columnTargetX=clamp((capmHeadRect.left+capmHeadRect.width*.5)/innerWidth*100,0,100);
        const columnTargetY=clamp((tableRect.top+tableRect.height*.46)/vh*100,0,100);
        ambientX+=(columnTargetX-ambientX)*comparisonLightEase;
        ambientY+=(columnTargetY-ambientY)*comparisonLightEase;
        ambientW+=(18-ambientW)*comparisonLightEase;
        ambientH+=(68-ambientH)*comparisonLightEase;
        ambientOpacity+=(1.02-ambientOpacity)*comparisonLightEase;
        const processTop=documentTop(processStory);
        const processDistance=Math.max(processStory.offsetHeight-vh,1);
        const processProgress=clamp((y-processTop)/processDistance,0,1);
        const processRect=processStory.getBoundingClientRect();
        const processEnter=clamp((vh*.9-processRect.top)/(vh*.72),0,1);
        const processExit=clamp((vh*.18-processRect.bottom)/(vh*.62),0,1);
        const processInfluence=processEnter*(1-processExit);
        const railRect=processRail.getBoundingClientRect();
        const processTargetX=clamp((railRect.left+railRect.width*.5)/innerWidth*100,0,100);
        const rawStageFloat=clamp(processProgress*4,0,4);
        const stageBase=Math.min(Math.floor(rawStageFloat),3);
        const stageFraction=rawStageFloat>=4?1:rawStageFloat-stageBase;
        const stageHold=.13;
        const stageTransition=clamp((stageFraction-stageHold)/(1-stageHold*2),0,1);
        const stageTransitionEase=stageTransition*stageTransition*(3-2*stageTransition);
        const stageFloat=rawStageFloat>=4?4:stageBase+stageTransitionEase;
        const nearestStage=Math.round(stageFloat);
        const isProcessLocked=rawStageFloat>=4||stageFraction<=stageHold||stageFraction>=1-stageHold;
        const lockedProcessProgress=stageFloat/4;
        const processTargetY=clamp((railRect.top+railRect.height*lockedProcessProgress)/vh*100,0,100);
        ambientX+=(processTargetX-ambientX)*processInfluence;
        ambientY+=(processTargetY-ambientY)*processInfluence;
        ambientW+=(24-ambientW)*processInfluence;
        ambientH+=(34-ambientH)*processInfluence;
        ambientOpacity+=(1.03-ambientOpacity)*processInfluence;
        const ctaRect=cta.getBoundingClientRect();
        const ctaHeadingRect=ctaHeading.getBoundingClientRect();
        const ctaLightProgress=clamp((vh*.96-ctaRect.top)/(vh*.72),0,1);
        ctaLightEase=ctaLightProgress*ctaLightProgress*(3-2*ctaLightProgress);
        const processOrbOpacity=1-clamp((ctaLightProgress-.02)/.30,0,1);
        processStory.style.setProperty('--process-orb-opacity',String(processOrbOpacity));
        const ctaTargetX=clamp((ctaHeadingRect.left+ctaHeadingRect.width*.5)/innerWidth*100,0,100);
        const ctaTargetY=clamp((ctaHeadingRect.top+ctaHeadingRect.height*.5)/vh*100,0,100);
        ambientX+=(ctaTargetX-ambientX)*ctaLightEase;
        ambientY+=(ctaTargetY-ambientY)*ctaLightEase;
        ambientW+=(38-ambientW)*ctaLightEase;
        ambientH+=(42-ambientH)*ctaLightEase;
        ambientOpacity+=(1.12-ambientOpacity)*ctaLightEase;
        document.documentElement.style.setProperty('--ambient-x',`${ambientX}%`);
        document.documentElement.style.setProperty('--ambient-y',`${ambientY}%`);
        document.documentElement.style.setProperty('--ambient-w',`${ambientW}vw`);
        document.documentElement.style.setProperty('--ambient-h',`${ambientH}vh`);
        document.documentElement.style.setProperty('--ambient-opacity',String(ambientOpacity));
        comparisonTable.style.setProperty('--column-glow-opacity',String(clamp((comparisonLightProgress-.58)/.42,0,1)));
        comparisonTable.style.setProperty('--column-glow-scale',String(.86+comparisonLightEase*.14));
        processStory.style.setProperty('--rail-progress',`${lockedProcessProgress*100}%`);
        processStory.style.setProperty('--orb-progress',`${lockedProcessProgress*100}%`);
        processStory.classList.toggle('process-is-locked',isProcessLocked);
        processMarkers.forEach((marker,index)=>marker.classList.toggle('is-active',isProcessLocked&&index===nearestStage));
        const glassFromIndex=Math.floor(stageFloat);
        const glassToIndex=Math.min(glassFromIndex+1,glassProfiles.length-1);
        const glassMix=stageFloat-glassFromIndex;
        const glassFrom=glassProfiles[glassFromIndex];
        const glassTo=glassProfiles[glassToIndex];
        const glassWidth=100;
        const glassHeight=100;
        const glassRadius=mobile?20:28;
        processGlass.style.setProperty('--glass-w',`${glassWidth}%`);
        processGlass.style.setProperty('--glass-h',`${glassHeight}%`);
        processGlass.style.setProperty('--glass-radius',`${glassRadius}px`);
        processSteps.forEach((step,index)=>{
          const delta=index-stageFloat;
          const distance=Math.abs(delta);
          const opacity=clamp(1-distance*1.35,0,1);
          step.style.opacity=String(opacity);
          step.style.setProperty('--step-y',`${delta*86}px`);
          step.style.setProperty('--step-scale',String(1-Math.min(distance,.8)*.035));
          step.style.setProperty('--step-blur','0px');
          step.classList.toggle('is-current',distance<.5);
        });
        processVisuals.forEach((visual,index)=>{
          const delta=index-stageFloat;
          const distance=Math.abs(delta);
          const opacity=clamp(1-distance*1.18,0,1);
          visual.style.opacity=String(opacity);
          visual.style.setProperty('--visual-x',`${delta*54}px`);
          visual.style.setProperty('--visual-y',`${delta*10}px`);
          visual.style.setProperty('--visual-scale',String(1-Math.min(distance,.9)*.035));
          visual.style.setProperty('--visual-blur','0px');
          visual.style.zIndex=String(10-Math.round(distance*2));
        });
        }else{
          document.documentElement.style.setProperty('--ambient-x',`${ambientX}%`);
          document.documentElement.style.setProperty('--ambient-y',`${ambientY}%`);
          document.documentElement.style.setProperty('--ambient-w',`${ambientW}vw`);
          document.documentElement.style.setProperty('--ambient-h',`${ambientH}vh`);
          document.documentElement.style.setProperty('--ambient-opacity',String(ambientOpacity));
          if(downstreamScenesWereActive){
            comparisonTable.style.setProperty('--column-glow-opacity','0');
            comparisonTable.style.setProperty('--column-glow-scale','.86');
            downstreamScenesWereActive=false;
          }
        }
        const heroScroll=document.querySelector('.hero-scroll');
        const heroProgress=clamp((y-heroScroll.offsetTop)/(heroScroll.offsetHeight-vh),0,1);
        const sceneExit=clamp((heroProgress-.955)/.045,0,1);
        const sceneEase=sceneExit*sceneExit*(3-2*sceneExit);
        document.documentElement.style.setProperty('--scene-opacity',String(1-sceneEase));
        document.documentElement.style.setProperty('--scene-exit-y',`${-sceneEase*6}vh`);
        document.documentElement.style.setProperty('--scene-scale',String(1-sceneEase*.012));
        const logos=[...document.querySelectorAll('.logo-tile')];
        const mobileHeadline=mobile?document.querySelector('.hero-content h2').getBoundingClientRect():null;
        const mobileStackShift=mobile
          ? parseFloat(getComputedStyle(document.querySelector('.hero-sticky')).getPropertyValue('--mobile-section-two-shift'))||0
          : 0;
        const mobileFirstLogoY=mobile
          ? Math.max(vh*.40-mobileStackShift,mobileHeadline.bottom+30-mobileStackShift)
          : 0;
const mobileLogoSize=mobile?Math.min(innerWidth*.19,76):0;
const mobileLogoGap=mobile?Math.min(76,Math.max(64,vh*.085)):0;
        const firstAdvantage=advantageCards[0];
        const firstRect=firstAdvantage.getBoundingClientRect();
        const firstDocumentTop=firstRect.top+y;
const heroTravel=heroScroll.offsetHeight-vh;
const morphStart=mobile
  ?heroScroll.offsetTop+heroTravel*.86
  :heroScroll.offsetTop+heroTravel*.86;
const morphEnd=mobile
  ?Math.max(morphStart+vh*.42,firstDocumentTop-vh*.58)
  :Math.max(morphStart+vh*.42,firstDocumentTop-vh*.58);
        const morphProgress=clamp((y-morphStart)/(morphEnd-morphStart),0,1);
        const morphEase=morphProgress*morphProgress*(3-2*morphProgress);
        if(mobile){
          const headRevealStart=morphStart;
          const headRevealProgress=clamp((y-headRevealStart)/Math.max(morphEnd-headRevealStart,1),0,1);
          const headPositionEase=headRevealProgress*headRevealProgress*(3-2*headRevealProgress);
          const headOpacity=clamp(headRevealProgress/.28,0,1);
          const headRightRevealProgress=headRevealProgress;
          const headRightPositionEase=headPositionEase;
          const headRightOpacity=clamp(headRightRevealProgress/.24,0,1);
          const headLeftOffset=-145*(1-headPositionEase);
          const headRightOffset=-112*(1-headRightPositionEase);
          headLeftBlock.style.setProperty('--head-left-opacity',String(headOpacity));
          headLeftBlock.style.setProperty('--head-left-y',`${headLeftOffset}px`);
          headRightBlock.style.setProperty('--head-right-opacity',String(headRightOpacity));
          headRightBlock.style.setProperty('--head-right-y',`${headRightOffset}px`);
        }else{
          if(!desktopHeadMetrics.ready)measureDesktopHead();
          const headRevealStart=heroScroll.offsetTop+heroScroll.offsetHeight-vh;
          const headHeight=desktopHeadMetrics.height;
          const startY=-headHeight-28;
          const lockY=clamp(vh*.22,118,188);
          const gridViewportAtLock=desktopHeadMetrics.gridTop-morphEnd;
          const availableHold=Math.max(32,gridViewportAtLock-(lockY+headHeight)-70);
          const holdDistance=Math.min(vh*.15,availableHold);
          const holdEnd=morphEnd+holdDistance;
          const exitDistance=Math.max(280,vh*.5);
          const exitEnd=holdEnd+exitDistance;
          const entryProgress=clamp((y-headRevealStart)/Math.max(morphEnd-headRevealStart,1),0,1);
          const exitProgress=clamp((y-holdEnd)/Math.max(exitEnd-holdEnd,1),0,1);
          const entryEase=entryProgress*entryProgress*(3-2*entryProgress);
          const exitEase=exitProgress*exitProgress*(3-2*exitProgress);
          const exitY=-headHeight-28;
          const viewportY=startY+(lockY-startY)*entryEase+(exitY-lockY)*exitEase;
          const opacity=clamp(entryProgress/.2,0,1)*(1-clamp((exitProgress-.6)/.4,0,1));
          setDesktopHeadTarget(viewportY,opacity);
        }
const morphContentProgress=clamp((morphProgress-(mobile?.82:.84))/(mobile?.18:.16),0,1);
        const contentEase=morphContentProgress*morphContentProgress*(3-2*morphContentProgress);
        const logoShrinkProgress=clamp((morphProgress-.28)/.72,0,1);
        const logoShrinkEase=logoShrinkProgress*logoShrinkProgress*(3-2*logoShrinkProgress);
const sourceSize=mobile?mobileLogoSize:Math.min(innerWidth*.18,280);
const sourceLeft=mobile?innerWidth-innerWidth*.03-sourceSize-30:innerWidth-.07*innerWidth-sourceSize+14;
const sourceTop=mobile?mobileFirstLogoY+3*mobileLogoGap+mobileStackShift:.675*vh;
        const targetTop=vh*.58;
const morphHandoffDuration=mobile?.035:.028;
const morphHandoffProgress=clamp(morphProgress/morphHandoffDuration,0,1);
const morphExit=mobile
  ?(morphProgress<.999?1:0)
  :(morphProgress<.999?1:0);
        const morphOpacity=morphHandoffProgress*morphExit;
        const currentMorphWidth=sourceSize+(firstRect.width-sourceSize)*morphEase;
        const currentMorphHeight=sourceSize+(firstRect.height-sourceSize)*morphEase;
        const finalIconSize=mobile?37:46;
        const startInset=mobile?1:7;
        const endInset=mobile?14:20;
        const startLogoWidth=Math.max(currentMorphWidth-startInset*2,finalIconSize);
        const startLogoHeight=Math.max(currentMorphHeight-startInset*2,finalIconSize);
        const platformInset=startInset+(endInset-startInset)*logoShrinkEase;
        morphPlatform.style.left=`${platformInset}px`;
        morphPlatform.style.top=`${platformInset}px`;
        morphPlatform.style.width=`${startLogoWidth+(finalIconSize-startLogoWidth)*logoShrinkEase}px`;
        morphPlatform.style.height=`${startLogoHeight+(finalIconSize-startLogoHeight)*logoShrinkEase}px`;
        morphPlatform.style.setProperty('--morph-logo-scale',String(1-logoShrinkEase*.1));
        morphUsp.style.setProperty('--morph-content',String(contentEase));
        logoMorph.style.left=`${sourceLeft+(firstRect.left-sourceLeft)*morphEase}px`;
        const morphTop=sourceTop+(targetTop-sourceTop)*morphEase;
        logoMorph.style.top=`${morphTop}px`;
        logoMorph.style.width=`${currentMorphWidth}px`;
        logoMorph.style.height=`${currentMorphHeight}px`;
        const sourceRadius=mobile?14:28;
        logoMorph.style.borderRadius=`${sourceRadius+(18-sourceRadius)*morphEase}px`;
        logoMorph.style.opacity=String(morphOpacity);
        logoMorph.style.transform=`scale(${1-morphEase*.015})`;
        const advantageProgress=clamp((y-morphEnd)/(advantages.offsetHeight*.58),0,1);
const mobileFirstCardReveal=morphProgress>=.999?1:0;
        advantageCards.forEach((card,index)=>{
          const cardProgress=clamp((advantageProgress-(index-1)*.12)/.2,0,1);
          const cardEase=index===0
            ?(mobile?mobileFirstCardReveal:(morphProgress>=.999?1:0))
            :1-Math.pow(1-cardProgress,3);
          card.style.setProperty('--adv-opacity',String(cardEase));
          card.style.setProperty('--adv-y',`${index===0?0:34*(1-cardEase)}px`);
          card.style.setProperty('--adv-scale',String(index===0?1:.975+cardEase*.025));
        });
        document.documentElement.style.setProperty('--hero-glow',String(.14+clamp(heroProgress*3,0,.64)));
        document.documentElement.style.setProperty('--glow-x',`${-6+heroProgress*30}vw`);
        document.documentElement.style.setProperty('--glow-y',`${14-heroProgress*42}vh`);
        document.documentElement.style.setProperty('--glow-scale',String(.72+heroProgress*.5));
        document.documentElement.style.setProperty('--headline-y',`${-heroProgress*vh*.42}px`);
        document.documentElement.style.setProperty('--headline-opacity',String(1-clamp((heroProgress-.02)*7.7,0,1)));
        const contentProgress=clamp((heroProgress-.18)*7,0,1);
        document.documentElement.style.setProperty('--content-opacity',String(contentProgress));
        document.documentElement.style.setProperty('--content-y',`${70*(1-contentProgress)}px`);
        const uspProgress=clamp((heroProgress-.25)*7,0,1);
        document.documentElement.style.setProperty('--usp-opacity',String(uspProgress));
        document.documentElement.style.setProperty('--usp-y',`${20*(1-uspProgress)}px`);
        let visibleLogos=0;
        logos.forEach((logo,index)=>{
          const start=index===0?.08:.38+(index-1)*.15;
          const duration=index===0?.24:.18;
          const local=clamp((heroProgress-start)/duration,0,1);
          const startY=(mobile&&index===0?.83:(index===0?.86:1.08+index*.025))*innerHeight;
          const finalRatios=[.055,.30,.56,.675];
          const finalY=mobile?mobileFirstLogoY+index*mobileLogoGap:finalRatios[index]*innerHeight;
          const finalX=mobile?[-23,-30,0,-30][index]:[0,-62,108,14][index];
          if(local>.45) visibleLogos=index+1;
          const handoff=index===3?1-morphHandoffProgress:1;
          logo.style.setProperty('--logo-opacity',String((index===0?Math.max(.3,local):local)*handoff));
          const startX=mobile&&index===0?14:45;
          logo.style.setProperty('--logo-x',`${startX*(1-local)+finalX*local}px`);
          logo.style.setProperty('--logo-y',`${startY*(1-local)+finalY*local}px`);
          logo.style.setProperty('--logo-scale',String(.82+local*.18));
          logo.style.setProperty('--logo-rotate',`${(index===0?0:(index-2)*2.4)*local}deg`);
        });
        if(downstreamScenesActive){
          const cp=clamp((y-cta.offsetTop+vh)/(cta.offsetHeight+vh),0,1);
          document.documentElement.style.setProperty('--cta-scale',.65+cp*.75);
          document.documentElement.style.setProperty('--cta-glow-opacity',String(ctaLightEase*.7));
          document.documentElement.style.setProperty('--cta-text-glow',String(ctaLightEase*.42));
        }
        });
      };
      let headMeasureFrame=0;
      const refreshDesktopHead=()=>{
        if(headMeasureFrame)cancelAnimationFrame(headMeasureFrame);
        headMeasureFrame=requestAnimationFrame(()=>{
          headMeasureFrame=0;
          measureDesktopHead();
          desktopHeadMotion.initialized=false;
          updateScene();
        });
      };
      addEventListener('scroll',updateScene,{passive:true});
      addEventListener('resize',refreshDesktopHead,{passive:true});
      mobileNavQuery.addEventListener('change',refreshDesktopHead);
      if(document.fonts?.ready)document.fonts.ready.then(refreshDesktopHead);
      measureDesktopHead();
      updateScene();
    }
